import { stringify } from 'qs';
import { plainToInstanceWithLVS } from '@goparrot/common';
import { BaseFacade } from '../../../common';
import { ListOrderV2Dto } from '../../dto';
import { CartExposeGroup } from '../../../cart';
import { OrderExposeGroup } from '../../interface';
import { ReadCartDto, ReadOrderDto } from '../../generated-dto';
export class OrderFacade extends BaseFacade {
    async getById(orderId) {
        return this.get(orderId);
    }
    async get(id) {
        return plainToInstanceWithLVS(ReadOrderDto, (await this.client.get(`/api/v2/orders/${id}`)).data, {
            groups: [CartExposeGroup.READ, OrderExposeGroup.READ],
        });
    }
    async list(body, pagination) {
        const { data } = await this.client.put('/api/v2/orders', body, {
            params: pagination,
            paramsSerializer: (params) => stringify(params),
        });
        return plainToInstanceWithLVS(ListOrderV2Dto, data, { groups: [OrderExposeGroup.READ] });
    }
    async synchronizeWithPOS(orderId) {
        const { data } = await this.client.get(`/api/v2/orders/${orderId}/synchronize-with-pos`);
        return { order: plainToInstanceWithLVS(ReadCartDto, data.order, { groups: [CartExposeGroup.READ] }), validationResult: data.validationResult };
    }
    async validateOrderElements(orderId) {
        const { data: order } = await this.client.get(`/api/v2/orders/${orderId}/validate-items`);
        return plainToInstanceWithLVS(ReadCartDto, order, { groups: [CartExposeGroup.READ] });
    }
    async addOrderStoreItemsToCart(orderId) {
        const { data: order } = await this.client.get(`/api/v2/orders/${orderId}/add-to-cart`);
        return plainToInstanceWithLVS(ReadCartDto, order, { groups: [CartExposeGroup.READ] });
    }
    async handleActions(uuid, actions) {
        return plainToInstanceWithLVS(ReadCartDto, (await this.client.patch(`/api/v2/orders/${uuid}/actions`, actions)).data, {
            groups: [CartExposeGroup.READ],
        });
    }
}
//# sourceMappingURL=OrderFacade.js.map